// extracted by mini-css-extract-plugin
module.exports = {"loginForm":"auth_loginForm__3O_y1"};